module.exports = __webpack_public_path__ + "img/ekyc-ibank-guide-02.9b406039.png";